import React from 'react';
import styled from '@emotion/styled';
// ---- external imports ----

import continueBtnProjection from '~/assets/images/baseAssets/continue-btn.png';
import { withProjection } from '~/hoc';
// ---- internal imports ----

import Asset from './BaseAssets';
import PopupModalBase from './PopupModalBase';
// ---- local imports ----


function NotEnoughCashModal(props) {
	if (!props.isOpen) {
		return null;
	}

	const scale = props.scale || 1;
	const fontSize = (props.fontSize || 19) * scale;

	return (
		<PopupModalBase
			title={props.title}
			scale={scale}
			data-testid={`${props['data-testid-prefix']}`}
		>
			<ConfirmText
				x={450 * scale}
				y={313 * scale}
				projection={{
					width: 474 * scale,
					height: 144 * scale
				}}

				fontSize={fontSize}
				data-testid={`${props['data-testid-prefix']}-text`}
			>
				<div>
					{props.children}
				</div>
			</ConfirmText>
			<ContinueButton
				x={618 * scale}
				y={493 * scale}
				scale={scale}
				onClick={props.onContinue}
				data-testid={`${props['data-testid-prefix']}-confirm-btn`}
			/>

		</PopupModalBase>
	);
}

const ConfirmText = styled(Asset.Text)`
	display: flex;
	place-items: center;
	line-height: 1.6;
	font-family: Wonderfull;
	color: #fdeea9;
`;

const ContinueButton = withProjection(Asset.Button, continueBtnProjection);

export default NotEnoughCashModal;
